import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-icon-bell-off-outline',
    templateUrl: './icon-bell-off-outline.component.html',
    styleUrls: ['./icon-bell-off-outline.component.scss'],
    standalone: false
})
export class IconBellOffOutlineComponent {
  @Input() tooltip?: string;
}
